import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { Note } from 'components/misc'
import { FormattedMessage } from 'react-intl'
import { apiDashboard } from 'helpers/decorators/api'

@apiDashboard.apiRevise()
class AssessorReport extends Component {
  static propTypes = {
    id: PropTypes.string,
    actionId: PropTypes.number,
    isAjRequest: PropTypes.bool,
    isActivityRequest: PropTypes.bool,
    isRpRequest: PropTypes.bool,
    revise: PropTypes.object.isRequired,
    getAjRequestAssessment: PropTypes.func.isRequired,
    getActivityRequestAssessment: PropTypes.func.isRequired,
    getRpRequestAssessment: PropTypes.func.isRequired,
    removeAssessments: PropTypes.func.isRequired
  }

  componentDidMount = () => {
    const { id, actionId } = this.props

    if (id && actionId) {
      this.handleGetAssessment(id, actionId)
    }
  }

  componentWillReceiveProps = nextProps => {
    const { actionId } = this.props

    if (!actionId && nextProps.actionId) {
      this.handleGetAssessment(nextProps.id, nextProps.actionId)
      return
    }

    // if changed
    if (actionId !== nextProps.actionId) {
      this.handleGetAssessment(nextProps.id, nextProps.actionId)
    }
  }

  componentWillUnmount = () => {
    this.props.removeAssessments()
  }

  handleGetAssessment = (id, actionId) => {
    const { isAjRequest, isActivityRequest, isRpRequest } = this.props

    isAjRequest && this.props.getAjRequestAssessment(id, actionId)
    isActivityRequest && this.props.getActivityRequestAssessment(id, actionId)
    isRpRequest && this.props.getRpRequestAssessment(id, actionId)
  }

  render() {
    const { isAjRequest, isActivityRequest, isRpRequest, revise } = this.props
    const displayNote = isAjRequest || isActivityRequest || isRpRequest

    return (
      <div>
        {displayNote &&
          get(revise, 'requestAssessment.note') && (
            <Note fontSize="1.2em">
              <strong>
                <FormattedMessage
                  id="label.note_from_participant"
                  defaultMessage="Note from participant"
                />
              </strong>
              <br /> {revise.requestAssessment.note}
            </Note>
          )}
      </div>
    )
  }
}

export default AssessorReport
